// extracted by mini-css-extract-plugin
export default {"form":"style_form__AC7RF","ingredientContainer":"style_ingredientContainer__eG3nO","removeIcon":"style_removeIcon__qTj3t","extraInputContainer":"style_extraInputContainer__HYCPN"};